import request from './request'
import appConfig from './../config/app'
import api from '../api'
import searchable from '@/services/searchable'
import resource from '@/services/resource'

export default {
  baseUrl: `${process.env.VUE_APP_FINANCE_API}/api`,
  url: 'billing-unit',
  ...api,
  ...resource,
  ...searchable,
  namespaced: true,
  strict: appConfig.store.strict,
  state: {
    baseURL: appConfig.services.finance.baseURl,
    url: '/api/fee-category',
    feeCategoryList: []
  },
  mutations: {
    setList (state, payload) {
      state.feeCategoryList = payload
    }
  },
  actions: {
    /**
     * Action to update field value
     *
     * @param {state, commit} commit
     * @param {payload} payload
     * @return void
     */
    async populateFeeCategoryList ({ state, commit }) {
      const payload = {
        baseURL: state.baseURL,
        url: state.url
      }

      await request.get({}, payload)
        .then(({ data }) => {
          commit('setList', data)
        })
        .catch(({ response }) => {
          throw response
        })
    },
    /**
     * empty listing
     *
     * @param {commit} commit
     * @return void
     */
    async clearFeeCategoryList ({ commit }) {
      commit('setList', [])
    }
  }
}
